import { render, staticRenderFns } from "./PromptCenter.vue?vue&type=template&id=072bf8ba&scoped=true&"
import script from "./PromptCenter.vue?vue&type=script&lang=js&"
export * from "./PromptCenter.vue?vue&type=script&lang=js&"
import style0 from "./PromptCenter.vue?vue&type=style&index=0&id=072bf8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bf8ba",
  null
  
)

export default component.exports